import "./vendor";
import { ClaimSubmission } from "../ClaimSubmission/claimSubmission";

new ClaimSubmission();
